import { BaseMutation } from './BaseMutation';
import * as OfScalar from "./OfScalar";
import * as OfSet from "./OfSet"; 
import * as OfSequence from "./OfSequence";
import * as OfMap from "./OfMap";
import * as OfRelation from './OfRelation';

enum ErrorCodes {
    Unknown = 'unknown',
    Reset = 'reset',
    Conflict = 'conflict',
    Forbidden = 'forbidden',
    Unreachable = 'unreachable'
}

export { OfScalar, OfSet, OfSequence, OfMap, OfRelation, BaseMutation, ErrorCodes };
